import React from "react";
import PropTypes from "prop-types";
import styles from "components/settings/cancel-subscription-modal.scss";
import { Modal } from "components/common/modal";
import { Button } from "components/common/button";

export const CancelSubscriptionModal = ({
  accountId,
  isCancelSubscriptionVisible,
  isChangePlanLoading,
  onHideCancelSubscription,
  onUpdatePlan
}) => (
  <Modal
    isVisible={ isCancelSubscriptionVisible }
    onClose={ onHideCancelSubscription }
    transitionName={ "cancel-subscription" }
  >
    <h2>Are you sure?</h2>
    <span>If you are, don&apos;t worry. You will still have access to your account </span>
    <span>and you can still submit up to 5 documents / month, on us.</span>
    <div className={ styles.controls }>
      <Button link onClick={ onHideCancelSubscription }>cancel</Button>
      <Button
        danger
        loading={ isChangePlanLoading }
        onClick={ () => onUpdatePlan(accountId, { planType: "DIY", subscriptionType: "MONTHLY" }) }
      >
        Cancel my subscription
      </Button>
    </div>
  </Modal>
);

CancelSubscriptionModal.propTypes = {
  accountId: PropTypes.string.isRequired,
  isCancelSubscriptionVisible: PropTypes.bool.isRequired,
  isChangePlanLoading: PropTypes.bool.isRequired,
  onHideCancelSubscription: PropTypes.func.isRequired,
  onUpdatePlan: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/settings/cancel-subscription-modal.jsx